<template>
  <div class="info-box" v-if="showBanner">
    <div class="flex-align-center">
      <span class="icon" aria-hidden="true"></span>
      <span class="text-base-semibold"> <slot name="txtHeadlineBanner">Zahlungserinnerung</slot></span>
    </div>
    <p class="text-sm">
      <slot name="txtDescriptionBanner"> Klicke jetzt auf den Button, um dein neues Dokument einsehen zu können.</slot>
    </p>
    <div>
      <button type="button" class="button button--secondary" @click="redirectToDocuments">
        <slot name="txtCTA">Jetzt ansehen</slot>
      </button>
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import { wrapQuery } from '@/helper/wrapGQLQuery'
import transaction from '@/mixins/transaction'

const AvailableDocTypes = ['dunnings']

export default {
  name: 'CustomerDocumentBanner',
  data() {
    return {
      filterDays: null,
      filterDocumentType: null,
      customerDocuments: {
        dunnings: []
      }
    }
  },
  computed: {
    showDocumentTypes() {
      return this.extraData?.showDocumentTypes || AvailableDocTypes
    },
    showBanner() {
      return this.customerDocuments.dunnings && this.customerDocuments.dunnings.some(dunning => !dunning.alreadyAccessed)
    }
  },
  mixins: [transaction('consumerDocumentList')],
  methods: {
    getFilter() {
      return {
        days: null,
        documentType: this.filterDocumentType,
        from: null,
        to: null
      }
    },
    redirectToDocuments() {
      window.location.href = this.targetPageLink
    }
  },
  props: {
    targetPageLink: {
      type: String,
      default: null
    }
  },
  apollo: {
    customerDocuments: function() {
      let parts = ''
      this.showDocumentTypes.forEach(value => {
        parts += `${value} { date identifier name url lastAccessDate alreadyAccessed } `
      })
      return wrapQuery(
        gql`query consumerDocumentList ($filter: CustomerDocumentFilterInput!) {
          customerDocuments(customerDocumentFilter: $filter) {
            ${parts}
          }
        }`,
        this,
        'customerDocuments',
        {
          filter: this.getFilter()
        }
      )
    }
  }
}
</script>
